import { Injectable } from '@angular/core';
import { ResponsePoliticaTermo } from '../classes/ResponsePoliticaTermo';

@Injectable()
export class PoliticaTermoService {

  private responseTermoUso: ResponsePoliticaTermo;

  public getResponseTermoUso(): ResponsePoliticaTermo {
    return this.responseTermoUso;
  }

  public setResponseTermoUso(responseTermoUso: ResponsePoliticaTermo): void {
    this.responseTermoUso = responseTermoUso;
  }

  public isAcceptedPoliciesAndTerms(): boolean {
    return this.getResponseTermoUso().isPrivacidadeAceita() && this.getResponseTermoUso().isTermoAceito();
  }

}



// WEBPACK FOOTER //
// ./src/app/resources/services/politica-termo.service.ts